import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';


const initialState = {    
    loading : false,
    error   : null,
    success : null,
}

const keywordListStart = (state,action) =>{
    return updateObject(state,
        {
            loading:true,
            error : null,
            
        })
}

const keywordListSuccess = (state,action) =>{
    return updateObject(state,
        {
            loading:false,
            error:null,
            success:null,
            [action.keyword]:action.lists
        })
}

const keywordListFail= (state,action) =>{
    return updateObject(state,
        {
            error:action.error,
            success:null,
            loading:false,
        })
}

const KeywordReducer = ( state = initialState, action) =>{
    switch(action.type){
        case actionTypes.KEYWORD_LIST_START: return keywordListStart(state,action);
        case actionTypes.KEYWORD_LIST_SUCCESS: return keywordListSuccess(state,action);
        case actionTypes.KEYWORD_LIST_FAIL: return keywordListFail(state,action);
        default:
            return state;

    }
}


export default KeywordReducer;